const LocationData = [
    {
        city: 'atlanta',
        state: 'ga',
        zip: '30318'
    },
    {
        city: 'augusta',
        state: 'ga',
        zip: '30907'
    },
    {
        city: 'austin',
        state: 'tx',
        zip: '78745'
    },
    {
        city: 'bakersfield',
        state: 'ca',
        zip: '93309'
    },
    {
        city: 'birmingham',
        state: 'al',
        zip: '35233'
    },
    {
        city: 'bluemound',
        state: 'tx',
        zip: '76131'
    },
    {
        city: 'charleston',
        state: 'sc',
        zip: '29401'
    },
    {
        city: 'charlotte',
        state: 'nc',
        zip: '28209'
    },
    {
        city: 'chattanooga',
        state: 'tn',
        zip: '37421'
    },
    {
        city: 'chesapeake',
        state: 'va',
        zip: '23320'
    },
    {
        city: 'cincinnati',
        state: 'oh',
        zip: '45255'
    },
    {
        city: 'columbia',
        state: 'sc',
        zip: '29210'
    },
    {
        city: 'columbus',
        state: 'oh',
        zip: '43228'
    },
    {
        city: 'corpuschristi',
        state: 'tx',
        zip: '78401'
    },
    {
        city: 'danvers',
        state: 'ma',
        zip: '01923'
    },
    {
        city: 'deerpark',
        state: 'ny',
        zip: '11729'
    },
    {
        city: 'delanco',
        state: 'nj',
        zip: '08075'
    },
    {
        city: 'denver',
        state: 'co',
        zip: '80216'
    },
    {
        city: 'downey',
        state: 'ca',
        zip: '90241'
    },
    {
        city: 'eastpointe',
        state: 'mi',
        zip: '48021'
    },
    {
        city: 'frisco',
        state: 'tx',
        zip: '75034'
    },
    {
        city: 'gambrills',
        state: 'md',
        zip: '21054'
    },
    {
        city: 'graham',
        state: 'nc',
        zip: '27253'
    },
    {
        city: 'greenville',
        state: 'sc',
        zip: '29607'
    },
    {
        city: 'hialeah',
        state: 'fl',
        zip: '33014'
    },
    {
        city: 'hickoryhills',
        state: 'il',
        zip: '60457'
    },
    {
        city: 'houston',
        state: 'tx',
        zip: '77079'
    },
    {
        city: 'indianapolis',
        state: 'in',
        zip: '46254'
    },
    {
        city: 'inwood',
        state: 'ny',
        zip: '11096'
    },
    {
        city: 'jacksonville',
        state: 'fl',
        zip: '32216'
    },
    {
        city: 'jeffersontown',
        state: 'ky',
        zip: '40299'
    },
    {
        city: 'kansascity',
        state: 'ks',
        zip: '66106'
    },
    {
        city: 'knoxville',
        state: 'tn',
        zip: '37923'
    },
    {
        city: 'lasvegas',
        state: 'nv',
        zip: '89102'
    },
    {
        city: 'macon',
        state: 'ga',
        zip: '31210'
    },
    {
        city: 'memphis',
        state: 'tn',
        zip: '38115'
    },
    {
        city: 'montclair',
        state: 'ca',
        zip: '91763'
    },
    {
        city: 'moriarty',
        state: 'nm',
        zip: '87035'
    },
    {
        city: 'naples',
        state: 'fl',
        zip: '34102'
    },
    {
        city: 'nashville',
        state: 'tn',
        zip: '37204'
    },
    {
        city: 'northversailles',
        state: 'pa',
        zip: '15137'
    },
    {
        city: 'oklahomacity',
        state: 'ok',
        zip: '73149'
    },
    {
        city: 'orlando',
        state: 'fl',
        zip: '32805'
    },
    {
        city: 'passaic',
        state: 'nj',
        zip: '07055'
    },
    {
        city: 'petersburg',
        state: 'va',
        zip: '23805'
    },
    {
        city: 'raleigh',
        state: 'nc',
        zip: '27609'
    },
    {
        city: 'sanantonio',
        state: 'tx',
        zip: '78249'
    },
    {
        city: 'sandiego',
        state: 'ca',
        zip: '92101'
    },
    {
        city: 'sanjose',
        state: 'ca',
        zip: '95111'
    },
    {
        city: 'southwindsor',
        state: 'ct',
        zip: '06074'
    },
    {
        city: 'stpeters',
        state: 'mo',
        zip: '63376'
    },
    {
        city: 'tampa',
        state: 'fl',
        zip: '33619'
    },
    {
        city: 'tempe',
        state: 'az',
        zip: '85281'
    },
    {
        city: 'templehills',
        state: 'md',
        zip: '20748'
    },
    {
        city: 'tolleson',
        state: 'az',
        zip: '85353'
    },
    {
        city: 'tucson',
        state: 'az',
        zip: '85713'
    },
    {
        city: 'warrensvilleheights',
        state: 'oh',
        zip: '44128'
    }
];

export default LocationData;
